import { useEffect, useState } from "react";
import * as configUtils from "util/config";

export const useComexDocs = () => {
    const [comexDocs, setComexDocs] = useState({});

    useEffect(() => {
        setComexDocs({
            codeStatute: configUtils.get("comex.thuban.code.statute", ""),
            codeFile1: configUtils.get("comex.thuban.code.file1"),
            codeFile2: configUtils.get("comex.thuban.code.file2"),
            codeFile3: configUtils.get("comex.thuban.code.file3"),
            codeFile4: configUtils.get("comex.thuban.code.file4"),
            codeFile5: configUtils.get("comex.thuban.code.file5"),
            codeFile6: configUtils.get("comex.thuban.code.file6"),
            codeFile7: configUtils.get("comex.thuban.code.file7"),
            codeFile8: configUtils.get("comex.thuban.code.file8"),
            codeFile9: configUtils.get("comex.thuban.code.file9"),
            codeFile10: configUtils.get("comex.thuban.code.file10"),
            codeFile11: configUtils.get("comex.thuban.code.file11"),
            codeFile12: configUtils.get("comex.thuban.code.file12"),
            codeFile13: configUtils.get("comex.thuban.code.file13"),
            codeFile14: configUtils.get("comex.thuban.code.file14"),
            codeFile15: configUtils.get("comex.thuban.code.file15"),
            codeFile16: configUtils.get("comex.thuban.code.file16"),
            codeFile17: configUtils.get("comex.thuban.code.file17"),
            codeFile18: configUtils.get("comex.thuban.code.file18"),
            codeFile19: configUtils.get("comex.thuban.code.file19"),
        });
    }, []);

    return comexDocs;
};

export default useComexDocs;
